import * as Bixby from '$/core';
import { LoginClearPreloadedData } from '../login/types';

export interface ClientState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  clients?: Bixby.Models.ClientSlim[];
  currentClient?: Bixby.Models.Client;
  isCreating?: boolean;
  createError?: Bixby.Models.BixbyError;
  clientUsers?: Bixby.Models.UserSlim[];
  clientUsersLoading: boolean;
}

export const CLIENTS_LOADING = 'CLIENTS_LOADING';
export const CLIENTS_FAILURE = 'CLIENTS_FAILURE';
export const CLIENTS_SUCCESS = 'CLIENTS_SUCCESS';
export const CLIENT_LOADING = 'CLIENT_LOADING';
export const CLIENT_SUCCESS = 'CLIENT_SUCCESS';
export const CLIENT_FAILURE = 'CLIENT_FAILURE';
export const CLIENT_DELETE = 'CLIENT_DELETE';
export const CLIENT_DELETE_SUCCESS = 'CLIENT_DELETE_SUCCESS';
export const CLIENT_DELETE_FAILURE = 'CLIENT_DELETE_FAILURE';
export const CREATE_CLIENT = 'CREATE_CLIENT';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_FAILURE = 'CREATE_CLIENT_FAILURE';
export const CLIENT_UPDATE_SUCCESS = 'CLIENT_UPDATE_SUCCESS_ACTION';
export const CLIENT_UPDATE_FAILURE = 'CLIENT_UPDATE_FAILURE_ACTION';
export const CLIENT_USERS_LOADING = 'CLIENT_USERS_LOADING';
export const CLIENT_USERS_SUCCESS = 'CLIENT_USERS_SUCCESS';
export const CLIENT_USERS_FAILURE = 'CLIENT_USERS_FAILURE';

interface ClientsLoading extends Bixby.Models.BixbyAction<undefined, typeof CLIENTS_LOADING> {
  type: typeof CLIENTS_LOADING;
}

interface ClientsSuccess extends Bixby.Models.BixbyAction<Bixby.Models.ClientSlim[], typeof CLIENTS_SUCCESS> {
  type: typeof CLIENTS_SUCCESS;
  payload: Bixby.Models.ClientSlim[];
}

interface ClientsFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CLIENTS_FAILURE> {
  type: typeof CLIENTS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface ClientLoading extends Bixby.Models.BixbyAction<undefined, typeof CLIENT_LOADING> {
  type: typeof CLIENT_LOADING;
}

interface ClientSuccess extends Bixby.Models.BixbyAction<Bixby.Models.Client, typeof CLIENT_SUCCESS> {
  type: typeof CLIENT_SUCCESS;
  payload?: Bixby.Models.Client;
}

interface ClientFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CLIENT_FAILURE> {
  type: typeof CLIENT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface CreateClient extends Bixby.Models.BixbyAction<Bixby.Models.CreateClientRequest, typeof CREATE_CLIENT> {
  type: typeof CREATE_CLIENT;
  payload: Bixby.Models.CreateClientRequest;
}

interface CreateClientSuccess extends Bixby.Models.BixbyAction<Bixby.Models.Client, typeof CREATE_CLIENT_SUCCESS> {
  type: typeof CREATE_CLIENT_SUCCESS;
  payload: Bixby.Models.Client;
}

interface CreateClientFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CREATE_CLIENT_FAILURE> {
  type: typeof CREATE_CLIENT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface UpdateClientSuccessAction
  extends Bixby.Models.BixbyAction<Bixby.Models.Client, typeof CLIENT_UPDATE_SUCCESS> {
  type: typeof CLIENT_UPDATE_SUCCESS;
  payload: Bixby.Models.Client;
}

interface UpdateClientFailureAction
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CLIENT_UPDATE_FAILURE> {
  type: typeof CLIENT_UPDATE_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface ClientUsersLoading extends Bixby.Models.BixbyAction<undefined, typeof CLIENT_USERS_LOADING> {
  type: typeof CLIENT_USERS_LOADING;
}
interface ClientUsersSuccess extends Bixby.Models.BixbyAction<Bixby.Models.UserSlim[], typeof CLIENT_USERS_SUCCESS> {
  type: typeof CLIENT_USERS_SUCCESS;
  payload: Bixby.Models.UserSlim[];
}
interface ClientUsersFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CLIENT_USERS_FAILURE> {
  type: typeof CLIENT_USERS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type ClientUpdateType = Pick<Partial<Bixby.Models.Client>, Exclude<keyof Bixby.Models.Client, 'id'>> &
  Pick<Bixby.Models.Client, 'id'>;

export type ClientActionTypes =
  | ClientsLoading
  | ClientsSuccess
  | ClientsFailure
  | ClientLoading
  | ClientSuccess
  | ClientFailure
  | CreateClient
  | CreateClientSuccess
  | CreateClientFailure
  | UpdateClientSuccessAction
  | UpdateClientFailureAction
  | ClientUsersLoading
  | ClientUsersSuccess
  | ClientUsersFailure
  | LoginClearPreloadedData;
